import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/apps', pathMatch: 'full' },
  { path: '', loadChildren: 'app/screens/root/root.module#RootModule' },
  { path: '', loadChildren: 'app/screens/togglit/togglit.module#TogglitModule' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /app/src/app/app.routes.ts